import { Link } from "react-router";
import { FREIGABE_DATENSCHUTZ, FREIGABE_KURZ } from "./kurztext";

/** W92 (D-1352, Nachtrag D-1354): Kurztext der Einwilligung als Absaetze, in Kurz- und Vorschau-Stufe vor jedem Knopf
 *  „Freigeben“. Der Link auf Abschnitt 5a der Datenschutzerklaerung oeffnet einen neuen Tab, ohne das Blatt zu verlassen; den
 *  Hinweis darauf traegt sein Name (Muster `RechtLink`), so bleibt der sichtbare Satz auch im Text des Absatzes wortgleich.
 *  Die Trefferflaeche im Satz waechst per ::before auf --touch (Abnahme Regel 4, Muster Suchfeld). Der Link wird nicht getrennt
 *  (hyphens-manual): getrennt zerfiele er in zwei Stuecke und die ::before-Flaeche haette die Breite 0 (Verifier R1, 393 px). */
export function FreigabeKurztext() {
  return (
    <div data-testid="freigabe.kurz">
      {FREIGABE_KURZ.map((z, i) => (
        <p key={i} className={`t-body hyphens-auto break-words px-4 text-pg-text-2 ${i === 0 ? "mt-4" : "mt-3"}`}>
          {z.vor}
          {z.link && (
            <Link
              to={FREIGABE_DATENSCHUTZ}
              target="_blank"
              rel="noopener"
              aria-label={`${z.link} (öffnet in einem neuen Tab)`}
              className="relative hyphens-manual text-pg-accent-text underline underline-offset-2 before:absolute before:inset-x-0 before:top-1/2 before:h-(--touch) before:-translate-y-1/2 before:content-[''] hover:opacity-70"
            >
              {z.link}
            </Link>
          )}
          {z.nach}
        </p>
      ))}
    </div>
  );
}
